import sheetBatchUpdateModal from "@/views/menu/sheet/operation/update/sheetBatchUpdateModal.vue";

export default {
    components: {
        sheetBatchUpdateModal
    },
    props: {},
    data () {
        return {
            showBatchUpdateModal: false,

            dshRenderName: undefined
        };
    },
    computed: {
        dshRender () {
            return this[this.dshRenderName];
        }
    },
    methods: {
        /* ------ 批量修改相关 --------- */
        // 点击批量修改
        clickBatchUpdate () {
            this.openBatchUpdateModal();
        },
        // 打开批量修改模态框
        openBatchUpdateModal () {
            this.dshRenderName = "batchUpdateModalRender";
            this.showBatchUpdateModal = true;
        },
        // 关闭批量修改模态框
        closeBatchUpdateModal () {
            this.dshRenderName = undefined;
            this.showBatchUpdateModal = false;
        },
        // 切换模态框
        toggleBatchUpdateModal (bool) {
            this.showBatchUpdateModal = bool;
        },

        // 批量修改模态框 渲染函数
        batchUpdateModalRender (h, params) {
            return this.showBatchUpdateModal
                ? h("sheet-batch-update-modal", {
                    props: {
                        companyId: this.companyId,
                        appId: this.appId,
                        modKey: this.modKey,
                        screenKey: this.screenKey,
                        value: this.showBatchUpdateModal,
                        dataIds: this.selectIds,
                        formList: this.curScreenFormList
                    },
                    on: {
                        input: this.toggleBatchUpdateModal,
                        batchUpdateCb: this.batchUpdateCb
                    }
                })
                : undefined;
        },
        // 回调 -编辑
        batchUpdateCb (datas) {
            // 保留除分页之外的筛选条件
            this.pagePropsObj = {
                page: 1,
                pagesize: 15
            };
            this.getListData();
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/operation/batchUpdateBtnMixin.js